import * as React from 'react';
import { Route, Switch } from 'react-router';

import { IRouteConfigComponent } from '@interfaces';

import { IRouterSwitchParams } from './types';

export const RouterSwitch = (routes: IRouteConfigComponent[]) => (_switchProps: IRouterSwitchParams) => (
	<Switch>
		{routes.map(({ component: Comp, ...route }) => (
			<Route
				key={route.path as string}
				{...route}
				render={(props) =>
					<Comp {...props} route={route} key={route.path as string} />}
			/>
		),
		)}
	</Switch>
);
